import styled from 'styled-components';

export const ContentWrapperStyled = styled.ul`
	position: relative;
	width: 100%;
	max-height: 100%;
	overflow-y: auto;
	padding: 0;
	margin: 0;
	padding-top: ${({ theme }) => theme.variables.padding * 0.25}px;
`;

export const NoEntriesWrapperStyled = styled.ul`
	text-align: center;
	position: relative;
	padding: ${({ theme }) => theme.variables.padding}px;
`;
